import { useState } from 'react';
import { EftPaymentDTO, PaymentClient, PaymentDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const usePaymentApi = () => {
    const apiClient = new PaymentClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: PaymentDTO) => {
        setIsLoading(true);
        try {
            return await apiClient.createPayment(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Payment');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: PaymentDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updatePayment(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Payment');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getPaymentById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Payment');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchPayments(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Payments');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deletePayment(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Payment');
        } finally {
            setIsLoading(false);
        }
    };

    const processEftPayment = async (payment: EftPaymentDTO) => {
        setIsLoading(true);
        try {
            await apiClient.eFTPaymentComplete(payment);
        } catch (err: any) {
            setError(err.message || 'Error completing Payment');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, processEftPayment, isLoading, error };
};